import { useExtendedServicePopup } from "@/hooks/useExtendedServicePopup";
import { ExtendedServicePayload } from "@/types/extendedViewService";
import { ExtendedViewItem, Receipt } from "@/types/receipt";

interface UseExtendedServiceHandlerParams {
  receipt: Receipt;
  lang: string;
  user_id?: string;
  receipt_id?: string;
  email?: string | null;
  phoneNumber?: string | null;
}

export const useExtendedServiceHandler = ({
  receipt,
  lang,
  user_id,
  receipt_id,
  email,
  phoneNumber,
}: UseExtendedServiceHandlerParams) => {
  const { openExtendedService, isLoading } = useExtendedServicePopup();

  const handleServiceClick = async (
    item: ExtendedViewItem,
    itemKey: string,
    options?: {
      articles?: ExtendedServicePayload["articles"];
      serviceViewPosition?: boolean | null;
    }
  ) => {
    if (!user_id || !receipt_id) {
      if (item.url) {
        window.open(item.url, "_blank", "noopener,noreferrer");
      }
      return;
    }

    const receiptEmail =
      item.share_url_email && email ? email : null;
    const receiptPhoneNumber =
      item.share_url_phone_number && phoneNumber ? phoneNumber : null;

    await openExtendedService(
      user_id,
      receipt_id,
      {
        client_service_scope: receipt.merchant.client_id,
        receipt_view_service_settings_id:
          item.receipt_view_service_settings_id,
        initiation_language_code: lang,
        receipt_url_email: receiptEmail,
        receipt_url_phone_number: receiptPhoneNumber,
        articles: options?.articles ?? null,
        service_view_position: options?.serviceViewPosition ?? true,
      },
      itemKey
    );
  };

  return { handleServiceClick, isLoading };
};
